import { Injectable } from '@angular/core';

import { RidangoReduxAction } from '@ridango/core';

@Injectable()
export class RouteTripActions {
    static FETCH_ROUTE_TRIP = '[Schedule]: Fetch route trip';
    static FETCH_ROUTE_TRIP_SUCCESS = '[Schedule]: Fetch route trip success';
    static FETCH_ROUTE_TRIP_FAIL = '[Schedule]: Fetch route trip fail';

    fetchRouteTrip(id): RidangoReduxAction {
        return {
            type: RouteTripActions.FETCH_ROUTE_TRIP,
            payload: id,
        };
    }

    fetchRouteTripSuccess(payload) {
        return {
            type: RouteTripActions.FETCH_ROUTE_TRIP_SUCCESS,
            payload: payload,
        };
    }

    fetchRouteTripFail() {
        return {
            type: RouteTripActions.FETCH_ROUTE_TRIP_FAIL,
        };
    }
}
